var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/inflection/lib/inflection.js
var require_inflection = __commonJS({
  "../../node_modules/inflection/lib/inflection.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.pluralize = pluralize2;
    exports.singularize = singularize2;
    exports.inflect = inflect;
    exports.camelize = camelize;
    exports.underscore = underscore;
    exports.humanize = humanize;
    exports.capitalize = capitalize;
    exports.dasherize = dasherize;
    exports.titleize = titleize;
    exports.demodulize = demodulize;
    exports.tableize = tableize;
    exports.classify = classify;
    exports.foreignKey = foreignKey;
    exports.ordinalize = ordinalize;
    exports.transform = transform;
    var uncountableWords = [
      // 'access',
      "accommodation",
      "adulthood",
      "advertising",
      "advice",
      "aggression",
      "aid",
      "air",
      "aircraft",
      "alcohol",
      "anger",
      "applause",
      "arithmetic",
      // 'art',
      "assistance",
      "athletics",
      // 'attention',
      "bacon",
      "baggage",
      // 'ballet',
      // 'beauty',
      "beef",
      // 'beer',
      // 'behavior',
      "biology",
      // 'billiards',
      "blood",
      "botany",
      // 'bowels',
      "bread",
      // 'business',
      "butter",
      "carbon",
      "cardboard",
      "cash",
      "chalk",
      "chaos",
      "chess",
      "crossroads",
      "countryside",
      // 'damage',
      "dancing",
      // 'danger',
      "deer",
      // 'delight',
      // 'dessert',
      "dignity",
      "dirt",
      // 'distribution',
      "dust",
      "economics",
      "education",
      "electricity",
      // 'employment',
      // 'energy',
      "engineering",
      "enjoyment",
      // 'entertainment',
      "envy",
      "equipment",
      "ethics",
      "evidence",
      "evolution",
      // 'failure',
      // 'faith',
      "fame",
      "fiction",
      // 'fish',
      "flour",
      "flu",
      "food",
      // 'freedom',
      // 'fruit',
      "fuel",
      "fun",
      // 'funeral',
      "furniture",
      "gallows",
      "garbage",
      "garlic",
      // 'gas',
      "genetics",
      // 'glass',
      "gold",
      "golf",
      "gossip",
      // 'grass',
      "gratitude",
      "grief",
      // 'ground',
      "guilt",
      "gymnastics",
      // 'hair',
      "happiness",
      "hardware",
      "harm",
      "hate",
      "hatred",
      "health",
      "heat",
      // 'height',
      "help",
      "homework",
      "honesty",
      "honey",
      "hospitality",
      "housework",
      "humour",
      "hunger",
      "hydrogen",
      "ice",
      "importance",
      "inflation",
      "information",
      // 'injustice',
      "innocence",
      // 'intelligence',
      "iron",
      "irony",
      "jam",
      // 'jealousy',
      // 'jelly',
      "jewelry",
      // 'joy',
      "judo",
      // 'juice',
      // 'justice',
      "karate",
      // 'kindness',
      "knowledge",
      // 'labour',
      "lack",
      // 'land',
      "laughter",
      "lava",
      "leather",
      "leisure",
      "lightning",
      "linguine",
      "linguini",
      "linguistics",
      "literature",
      "litter",
      "livestock",
      "logic",
      "loneliness",
      // 'love',
      "luck",
      "luggage",
      "macaroni",
      "machinery",
      "magic",
      // 'mail',
      "management",
      "mankind",
      "marble",
      "mathematics",
      "mayonnaise",
      "measles",
      // 'meat',
      // 'metal',
      "methane",
      "milk",
      "minus",
      "money",
      // 'moose',
      "mud",
      "music",
      "mumps",
      "nature",
      "news",
      "nitrogen",
      "nonsense",
      "nurture",
      "nutrition",
      "obedience",
      "obesity",
      // 'oil',
      "oxygen",
      // 'paper',
      // 'passion',
      "pasta",
      "patience",
      // 'permission',
      "physics",
      "poetry",
      "pollution",
      "poverty",
      // 'power',
      "pride",
      // 'production',
      // 'progress',
      // 'pronunciation',
      "psychology",
      "publicity",
      "punctuation",
      // 'quality',
      // 'quantity',
      "quartz",
      "racism",
      // 'rain',
      // 'recreation',
      "relaxation",
      "reliability",
      "research",
      "respect",
      "revenge",
      "rice",
      "rubbish",
      "rum",
      "safety",
      // 'salad',
      // 'salt',
      // 'sand',
      // 'satire',
      "scenery",
      "seafood",
      "seaside",
      "series",
      "shame",
      "sheep",
      "shopping",
      // 'silence',
      "sleep",
      // 'slang'
      "smoke",
      "smoking",
      "snow",
      "soap",
      "software",
      "soil",
      // 'sorrow',
      // 'soup',
      "spaghetti",
      // 'speed',
      "species",
      // 'spelling',
      // 'sport',
      "steam",
      // 'strength',
      "stuff",
      "stupidity",
      // 'success',
      // 'sugar',
      "sunshine",
      "symmetry",
      // 'tea',
      "tennis",
      "thirst",
      "thunder",
      "timber",
      // 'time',
      // 'toast',
      // 'tolerance',
      // 'trade',
      "traffic",
      "transportation",
      // 'travel',
      "trust",
      // 'understanding',
      "underwear",
      "unemployment",
      "unity",
      // 'usage',
      "validity",
      "veal",
      "vegetation",
      "vegetarianism",
      "vengeance",
      "violence",
      // 'vision',
      "vitality",
      "warmth",
      // 'water',
      "wealth",
      "weather",
      // 'weight',
      "welfare",
      "wheat",
      // 'whiskey',
      // 'width',
      "wildlife",
      // 'wine',
      "wisdom",
      // 'wood',
      // 'wool',
      // 'work',
      // 'yeast',
      "yoga",
      "zinc",
      "zoology"
    ];
    var regex = {
      plural: {
        men: new RegExp("^(m|wom)en$", "gi"),
        people: new RegExp("(pe)ople$", "gi"),
        children: new RegExp("(child)ren$", "gi"),
        tia: new RegExp("([ti])a$", "gi"),
        analyses: new RegExp("((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)ses$", "gi"),
        databases: new RegExp("(database)s$", "gi"),
        drives: new RegExp("(drive)s$", "gi"),
        hives: new RegExp("(hi|ti)ves$", "gi"),
        curves: new RegExp("(curve)s$", "gi"),
        lrves: new RegExp("([lr])ves$", "gi"),
        aves: new RegExp("([a])ves$", "gi"),
        foves: new RegExp("([^fo])ves$", "gi"),
        movies: new RegExp("(m)ovies$", "gi"),
        aeiouyies: new RegExp("([^aeiouy]|qu)ies$", "gi"),
        series: new RegExp("(s)eries$", "gi"),
        xes: new RegExp("(x|ch|ss|sh)es$", "gi"),
        mice: new RegExp("([m|l])ice$", "gi"),
        buses: new RegExp("(bus)es$", "gi"),
        oes: new RegExp("(o)es$", "gi"),
        shoes: new RegExp("(shoe)s$", "gi"),
        crises: new RegExp("(cris|ax|test)es$", "gi"),
        octopuses: new RegExp("(octop|vir)uses$", "gi"),
        aliases: new RegExp("(alias|canvas|status|campus)es$", "gi"),
        summonses: new RegExp("^(summons|bonus)es$", "gi"),
        oxen: new RegExp("^(ox)en", "gi"),
        matrices: new RegExp("(matr)ices$", "gi"),
        vertices: new RegExp("(vert|ind)ices$", "gi"),
        feet: new RegExp("^feet$", "gi"),
        teeth: new RegExp("^teeth$", "gi"),
        geese: new RegExp("^geese$", "gi"),
        quizzes: new RegExp("(quiz)zes$", "gi"),
        whereases: new RegExp("^(whereas)es$", "gi"),
        criteria: new RegExp("^(criteri)a$", "gi"),
        genera: new RegExp("^genera$", "gi"),
        ss: new RegExp("ss$", "gi"),
        s: new RegExp("s$", "gi")
      },
      singular: {
        man: new RegExp("^(m|wom)an$", "gi"),
        person: new RegExp("(pe)rson$", "gi"),
        child: new RegExp("(child)$", "gi"),
        drive: new RegExp("(drive)$", "gi"),
        ox: new RegExp("^(ox)$", "gi"),
        axis: new RegExp("(ax|test)is$", "gi"),
        octopus: new RegExp("(octop|vir)us$", "gi"),
        alias: new RegExp("(alias|status|canvas|campus)$", "gi"),
        summons: new RegExp("^(summons|bonus)$", "gi"),
        bus: new RegExp("(bu)s$", "gi"),
        buffalo: new RegExp("(buffal|tomat|potat)o$", "gi"),
        tium: new RegExp("([ti])um$", "gi"),
        sis: new RegExp("sis$", "gi"),
        ffe: new RegExp("(?:([^f])fe|([lr])f)$", "gi"),
        focus: new RegExp("^(focus)$", "gi"),
        hive: new RegExp("(hi|ti)ve$", "gi"),
        aeiouyy: new RegExp("([^aeiouy]|qu)y$", "gi"),
        x: new RegExp("(x|ch|ss|sh)$", "gi"),
        matrix: new RegExp("(matr)ix$", "gi"),
        vertex: new RegExp("(vert|ind)ex$", "gi"),
        mouse: new RegExp("([m|l])ouse$", "gi"),
        foot: new RegExp("^foot$", "gi"),
        tooth: new RegExp("^tooth$", "gi"),
        goose: new RegExp("^goose$", "gi"),
        quiz: new RegExp("(quiz)$", "gi"),
        whereas: new RegExp("^(whereas)$", "gi"),
        criterion: new RegExp("^(criteri)on$", "gi"),
        genus: new RegExp("^genus$", "gi"),
        s: new RegExp("s$", "gi"),
        common: new RegExp("$", "gi")
      }
    };
    var pluralRules = [
      // do not replace if its already a plural word
      [regex.plural.men],
      [regex.plural.people],
      [regex.plural.children],
      [regex.plural.tia],
      [regex.plural.analyses],
      [regex.plural.databases],
      [regex.plural.drives],
      [regex.plural.hives],
      [regex.plural.curves],
      [regex.plural.lrves],
      [regex.plural.foves],
      [regex.plural.aeiouyies],
      [regex.plural.series],
      [regex.plural.movies],
      [regex.plural.xes],
      [regex.plural.mice],
      [regex.plural.buses],
      [regex.plural.oes],
      [regex.plural.shoes],
      [regex.plural.crises],
      [regex.plural.octopuses],
      [regex.plural.aliases],
      [regex.plural.summonses],
      [regex.plural.oxen],
      [regex.plural.matrices],
      [regex.plural.feet],
      [regex.plural.teeth],
      [regex.plural.geese],
      [regex.plural.quizzes],
      [regex.plural.whereases],
      [regex.plural.criteria],
      [regex.plural.genera],
      // original rule
      [regex.singular.man, "$1en"],
      [regex.singular.person, "$1ople"],
      [regex.singular.child, "$1ren"],
      [regex.singular.drive, "$1s"],
      [regex.singular.ox, "$1en"],
      [regex.singular.axis, "$1es"],
      [regex.singular.octopus, "$1uses"],
      [regex.singular.alias, "$1es"],
      [regex.singular.summons, "$1es"],
      [regex.singular.bus, "$1ses"],
      [regex.singular.buffalo, "$1oes"],
      [regex.singular.tium, "$1a"],
      [regex.singular.sis, "ses"],
      [regex.singular.ffe, "$1$2ves"],
      [regex.singular.focus, "$1es"],
      [regex.singular.hive, "$1ves"],
      [regex.singular.aeiouyy, "$1ies"],
      [regex.singular.matrix, "$1ices"],
      [regex.singular.vertex, "$1ices"],
      [regex.singular.x, "$1es"],
      [regex.singular.mouse, "$1ice"],
      [regex.singular.foot, "feet"],
      [regex.singular.tooth, "teeth"],
      [regex.singular.goose, "geese"],
      [regex.singular.quiz, "$1zes"],
      [regex.singular.whereas, "$1es"],
      [regex.singular.criterion, "$1a"],
      [regex.singular.genus, "genera"],
      [regex.singular.s, "s"],
      [regex.singular.common, "s"]
    ];
    var singularRules = [
      // do not replace if its already a singular word
      [regex.singular.man],
      [regex.singular.person],
      [regex.singular.child],
      [regex.singular.drive],
      [regex.singular.ox],
      [regex.singular.axis],
      [regex.singular.octopus],
      [regex.singular.alias],
      [regex.singular.summons],
      [regex.singular.bus],
      [regex.singular.buffalo],
      [regex.singular.tium],
      [regex.singular.sis],
      [regex.singular.ffe],
      [regex.singular.focus],
      [regex.singular.hive],
      [regex.singular.aeiouyy],
      [regex.singular.x],
      [regex.singular.matrix],
      [regex.singular.mouse],
      [regex.singular.foot],
      [regex.singular.tooth],
      [regex.singular.goose],
      [regex.singular.quiz],
      [regex.singular.whereas],
      [regex.singular.criterion],
      [regex.singular.genus],
      // original rule
      [regex.plural.men, "$1an"],
      [regex.plural.people, "$1rson"],
      [regex.plural.children, "$1"],
      [regex.plural.databases, "$1"],
      [regex.plural.drives, "$1"],
      [regex.plural.genera, "genus"],
      [regex.plural.criteria, "$1on"],
      [regex.plural.tia, "$1um"],
      [regex.plural.analyses, "$1$2sis"],
      [regex.plural.hives, "$1ve"],
      [regex.plural.curves, "$1"],
      [regex.plural.lrves, "$1f"],
      [regex.plural.aves, "$1ve"],
      [regex.plural.foves, "$1fe"],
      [regex.plural.movies, "$1ovie"],
      [regex.plural.aeiouyies, "$1y"],
      [regex.plural.series, "$1eries"],
      [regex.plural.xes, "$1"],
      [regex.plural.mice, "$1ouse"],
      [regex.plural.buses, "$1"],
      [regex.plural.oes, "$1"],
      [regex.plural.shoes, "$1"],
      [regex.plural.crises, "$1is"],
      [regex.plural.octopuses, "$1us"],
      [regex.plural.aliases, "$1"],
      [regex.plural.summonses, "$1"],
      [regex.plural.oxen, "$1"],
      [regex.plural.matrices, "$1ix"],
      [regex.plural.vertices, "$1ex"],
      [regex.plural.feet, "foot"],
      [regex.plural.teeth, "tooth"],
      [regex.plural.geese, "goose"],
      [regex.plural.quizzes, "$1"],
      [regex.plural.whereases, "$1"],
      [regex.plural.ss, "ss"],
      [regex.plural.s, ""]
    ];
    var nonTitlecasedWords = [
      "and",
      "or",
      "nor",
      "a",
      "an",
      "the",
      "so",
      "but",
      "to",
      "of",
      "at",
      "by",
      "from",
      "into",
      "on",
      "onto",
      "off",
      "out",
      "in",
      "over",
      "with",
      "for"
    ];
    var idSuffix = new RegExp("(_ids|_id)$", "g");
    var underbar = new RegExp("_", "g");
    var spaceOrUnderbar = new RegExp("[ _]", "g");
    var uppercase = new RegExp("([A-Z])", "g");
    var underbarPrefix = new RegExp("^_");
    function applyRules(str, rules, skip, override) {
      if (override) {
        return override;
      } else {
        if (skip.includes(str.toLocaleLowerCase())) {
          return str;
        }
        for (const rule of rules) {
          if (str.match(rule[0])) {
            if (rule[1] !== void 0) {
              return str.replace(rule[0], rule[1]);
            }
            return str;
          }
        }
      }
      return str;
    }
    function pluralize2(str, plural) {
      return applyRules(str, pluralRules, uncountableWords, plural);
    }
    function singularize2(str, singular) {
      return applyRules(str, singularRules, uncountableWords, singular);
    }
    function inflect(str, count, singular, plural) {
      if (isNaN(count))
        return str;
      if (count === 1) {
        return applyRules(str, singularRules, uncountableWords, singular);
      } else {
        return applyRules(str, pluralRules, uncountableWords, plural);
      }
    }
    function camelize(str, lowFirstLetter) {
      const strPath = str.split("/");
      const j = strPath.length;
      let strArr, k, l, first;
      for (let i = 0; i < j; i++) {
        strArr = strPath[i].split("_");
        k = 0;
        l = strArr.length;
        for (; k < l; k++) {
          if (k !== 0) {
            strArr[k] = strArr[k].toLowerCase();
          }
          first = strArr[k].charAt(0);
          first = lowFirstLetter && i === 0 && k === 0 ? first.toLowerCase() : first.toUpperCase();
          strArr[k] = first + strArr[k].substring(1);
        }
        strPath[i] = strArr.join("");
      }
      return strPath.join("::");
    }
    function underscore(str, allUpperCase) {
      if (allUpperCase && str === str.toUpperCase())
        return str;
      const strPath = str.split("::");
      const j = strPath.length;
      for (let i = 0; i < j; i++) {
        strPath[i] = strPath[i].replace(uppercase, "_$1");
        strPath[i] = strPath[i].replace(underbarPrefix, "");
      }
      return strPath.join("/").toLowerCase();
    }
    function humanize(str, lowFirstLetter) {
      str = str.toLowerCase();
      str = str.replace(idSuffix, "");
      str = str.replace(underbar, " ");
      if (!lowFirstLetter) {
        str = capitalize(str);
      }
      return str;
    }
    function capitalize(str) {
      str = str.toLowerCase();
      return str.substring(0, 1).toUpperCase() + str.substring(1);
    }
    function dasherize(str) {
      return str.replace(spaceOrUnderbar, "-");
    }
    function titleize(str) {
      str = str.toLowerCase().replace(underbar, " ");
      const strArr = str.split(" ");
      const j = strArr.length;
      let d, l;
      for (let i = 0; i < j; i++) {
        d = strArr[i].split("-");
        l = d.length;
        for (let k = 0; k < l; k++) {
          if (nonTitlecasedWords.indexOf(d[k].toLowerCase()) < 0) {
            d[k] = capitalize(d[k]);
          }
        }
        strArr[i] = d.join("-");
      }
      str = strArr.join(" ");
      str = str.substring(0, 1).toUpperCase() + str.substring(1);
      return str;
    }
    function demodulize(str) {
      const strArr = str.split("::");
      return strArr[strArr.length - 1];
    }
    function tableize(str) {
      str = underscore(str);
      str = pluralize2(str);
      return str;
    }
    function classify(str) {
      str = camelize(str);
      str = singularize2(str);
      return str;
    }
    function foreignKey(str, dropIdUbar) {
      str = demodulize(str);
      str = underscore(str) + (dropIdUbar ? "" : "_") + "id";
      return str;
    }
    function ordinalize(str) {
      const strArr = str.split(" ");
      const j = strArr.length;
      for (let i = 0; i < j; i++) {
        const k = parseInt(strArr[i], 10);
        if (!isNaN(k)) {
          const ltd = strArr[i].substring(strArr[i].length - 2);
          const ld = strArr[i].substring(strArr[i].length - 1);
          let suf = "th";
          if (ltd != "11" && ltd != "12" && ltd != "13") {
            if (ld === "1") {
              suf = "st";
            } else if (ld === "2") {
              suf = "nd";
            } else if (ld === "3") {
              suf = "rd";
            }
          }
          strArr[i] += suf;
        }
      }
      return strArr.join(" ");
    }
    var transformFunctions = {
      pluralize: pluralize2,
      singularize: singularize2,
      camelize,
      underscore,
      humanize,
      capitalize,
      dasherize,
      titleize,
      demodulize,
      tableize,
      classify,
      foreignKey,
      ordinalize
    };
    function transform(str, arr) {
      const j = arr.length;
      for (let i = 0; i < j; i++) {
        const method = arr[i];
        const methodFn = transformFunctions[method];
        if (methodFn) {
          str = methodFn(str);
        }
      }
      return str;
    }
  }
});

// src/components/CompoundInputs/CompoundInputFieldNew.tsx
import { FormControl, FormErrorMessage, FormHelperText } from "@chakra-ui/react";
import { Field } from "react-final-form";

// src/components/FormErrors/FormErrors.tsx
import { Box } from "@chakra-ui/react";
import { Fragment, jsx } from "react/jsx-runtime";
var FormError = ({ formError, as }) => {
  if (typeof formError !== "string") {
    return null;
  }
  return /* @__PURE__ */ jsx(Box, { as, children: formError });
};
var FormErrors = ({ formError, as }) => {
  return Array.isArray(formError) ? /* @__PURE__ */ jsx(Fragment, { children: formError.map((formErrorItem, index) => /* @__PURE__ */ jsx(
    FormError,
    {
      as,
      formError: formErrorItem
    },
    `${String(formErrorItem)}-${index}`
  )) }) : /* @__PURE__ */ jsx(FormError, { as, formError });
};

// src/components/Label/Label.tsx
import { Flex, FormLabel } from "@chakra-ui/react";

// src/components/InfoPopover/InfoPopover.tsx
import {
  IconButton,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Portal
} from "@chakra-ui/react";
import { InfoPopoverIcon } from "@sequencehq/core-components";
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var InfoPopover = ({
  title,
  body,
  placement,
  padding,
  minimal
}) => /* @__PURE__ */ jsxs(Popover, { placement: placement || "left", variant: "fieldInfo", trigger: "hover", children: [
  /* @__PURE__ */ jsx2(PopoverTrigger, { children: /* @__PURE__ */ jsx2(
    IconButton,
    {
      minWidth: minimal ? "16px" : "24px",
      height: minimal ? "16px" : "24px",
      "aria-label": "Show info",
      icon: /* @__PURE__ */ jsx2(InfoPopoverIcon, {}),
      variant: "clear",
      padding: padding || "0px"
    }
  ) }),
  /* @__PURE__ */ jsx2(Portal, { children: /* @__PURE__ */ jsxs(PopoverContent, { children: [
    title ? /* @__PURE__ */ jsx2(PopoverHeader, { children: title }) : null,
    /* @__PURE__ */ jsx2(PopoverBody, { pt: title ? "0" : "20px", children: body })
  ] }) })
] });

// src/components/Label/Label.tsx
import styled from "@emotion/styled";
import { Lato13Bold, Lato14Bold, Lato18Bold } from "@sequencehq/design-tokens";
import { match } from "ts-pattern";
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var StyledLabel = styled(FormLabel)`
  ${({ size }) => match(size).with("lg", () => Lato18Bold).with("sm", () => Lato13Bold).otherwise(() => Lato14Bold)}
`;
var Label = ({
  children,
  isOptional,
  infoPopover,
  ...props
}) => {
  if (!children && !infoPopover) {
    return null;
  }
  return /* @__PURE__ */ jsxs2(Flex, { justifyContent: "space-between", alignItems: "end", height: "24px", pb: 2, children: [
    children ? /* @__PURE__ */ jsx3(StyledLabel, { optionalIndicator: isOptional && " (optional)", ...props, children }) : null,
    infoPopover ? /* @__PURE__ */ jsx3(InfoPopover, { ...infoPopover }) : null
  ] });
};

// src/components/CompoundInputs/CompoundInputFieldNew.tsx
import { useEffect } from "react";
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var CompoundInputFieldNew = (props) => /* @__PURE__ */ jsx4(Field, { name: props.fieldName, validate: props.validate, children: ({ input, meta }) => /* @__PURE__ */ jsx4(Content, { input, meta, ...props }) });
var Content = (props) => {
  const {
    input,
    meta,
    fieldName,
    fieldLabel,
    infoPopover,
    isOptional,
    validate,
    formHelperText,
    Component,
    labelSize = "md",
    modelId,
    setModelId,
    ...rest
  } = props;
  const errorMessage = meta.error ?? meta.submitError;
  const isInvalid = Boolean(errorMessage && meta?.touched);
  useEffect(() => {
    if (setModelId && meta.initial && !modelId) {
      setModelId(meta.initial);
    }
  }, [meta.initial]);
  useEffect(() => {
    if (setModelId) {
      input.onChange(modelId);
    }
  }, [modelId]);
  return /* @__PURE__ */ jsxs3(FormControl, { isInvalid, width: rest?.width || "100%", children: [
    /* @__PURE__ */ jsx4(Label, { infoPopover, isOptional, size: labelSize, children: fieldLabel }),
    /* @__PURE__ */ jsx4(
      Component,
      {
        ...props,
        isInvalid,
        value: input.value,
        onChange: setModelId ?? input.onChange
      }
    ),
    errorMessage ? /* @__PURE__ */ jsx4(FormErrors, { formError: errorMessage, as: FormErrorMessage }) : formHelperText ? /* @__PURE__ */ jsx4(FormHelperText, { children: formHelperText }) : null
  ] });
};

// src/components/CompoundInputs/CustomSelectNew.tsx
import { useSelect } from "downshift";
import {
  useMultiStyleConfig as useMultiStyleConfig3,
  Box as Box3,
  Popover as Popover2,
  PopoverAnchor,
  PopoverContent as PopoverContent2,
  PopoverBody as PopoverBody2,
  Flex as Flex3,
  Portal as Portal2
} from "@chakra-ui/react";
import { useRef } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import { SelectIcon } from "@sequencehq/core-components";
import {
  errorBoxShadow,
  focusedBoxShadow,
  standardBorder
} from "@sequencehq/core-theme";
import { RedRed60, IndigoIndigo50 as IndigoIndigo503 } from "@sequencehq/design-tokens";

// src/components/VirtualList/ListButton.tsx
import { Button, useMultiStyleConfig } from "@chakra-ui/react";
import { standardHoverBackground } from "@sequencehq/core-theme";
import { jsx as jsx5 } from "react/jsx-runtime";
var ListButton = ({
  label,
  leftIcon,
  onClick,
  px
}) => {
  const styles = useMultiStyleConfig("CustomSelect");
  return /* @__PURE__ */ jsx5(
    Button,
    {
      __css: styles.item,
      leftIcon,
      onClick,
      color: "grey.100",
      fontWeight: "700",
      display: "flex",
      px: px ? px : 4,
      py: 2,
      alignItems: "center",
      _hover: {
        bg: standardHoverBackground
      },
      children: label
    }
  );
};

// src/components/VirtualList/ListContent.tsx
import { Text, HStack } from "@chakra-ui/react";
import { GreyGrey60, IndigoIndigo50 } from "@sequencehq/design-tokens";
import { jsx as jsx6, jsxs as jsxs4 } from "react/jsx-runtime";
var ListContent = (props) => {
  const { title, subTitle, icon, tag, px, selectedValue } = props;
  return /* @__PURE__ */ jsxs4(HStack, { spacing: 2, px: px ? px : 4, py: 3, width: "100%", children: [
    icon,
    /* @__PURE__ */ jsx6(
      Text,
      {
        textOverflow: "ellipsis",
        overflow: "hidden",
        color: selectedValue ? IndigoIndigo50 : void 0,
        children: title
      }
    ),
    /* @__PURE__ */ jsx6(Text, { color: GreyGrey60, children: subTitle }),
    tag
  ] });
};

// src/components/VirtualList/ListDivider.tsx
import { internalBorder } from "@sequencehq/core-theme";
import { Flex as Flex2 } from "@chakra-ui/react";
import { jsx as jsx7 } from "react/jsx-runtime";
var ListDivider = () => /* @__PURE__ */ jsx7(Flex2, { borderBottom: internalBorder, my: 2, width: "100%" });

// src/components/VirtualList/ListTitle.tsx
import { useMultiStyleConfig as useMultiStyleConfig2, Text as Text2 } from "@chakra-ui/react";
import { GreyGrey60 as GreyGrey602 } from "@sequencehq/design-tokens";
import { jsx as jsx8 } from "react/jsx-runtime";
var ListTitle = ({ title, px }) => {
  const styles = useMultiStyleConfig2("CustomSelect");
  return /* @__PURE__ */ jsx8(
    Text2,
    {
      ...styles.groupTitle,
      px: px ? px : 4,
      pt: 3,
      pb: 2,
      backgroundColor: "white",
      color: GreyGrey602,
      children: title
    }
  );
};

// src/components/VirtualList/VirtualList.tsx
import { Box as Box2, Icon, List, ListItem } from "@chakra-ui/react";
import { standardHoverBackground as standardHoverBackground2 } from "@sequencehq/core-theme";
import { useVirtualizer } from "@tanstack/react-virtual";

// src/components/VirtualList/tokenToOption.tsx
import { match as match2 } from "ts-pattern";
import { jsx as jsx9 } from "react/jsx-runtime";
var tokenToOption = ({
  px,
  token,
  itemToContent,
  selectedValue
}) => {
  return match2(token).with({ type: "model" }, ({ model }) => /* @__PURE__ */ jsx9(
    ListContent,
    {
      ...itemToContent(model),
      px,
      selectedValue
    }
  )).with({ type: "button" }, ({ label, leftIcon, onClick }) => /* @__PURE__ */ jsx9(ListButton, { label, leftIcon, onClick, px })).with({ type: "divider" }, () => /* @__PURE__ */ jsx9(ListDivider, {})).with({ type: "title" }, ({ title }) => /* @__PURE__ */ jsx9(ListTitle, { title, px })).exhaustive();
};

// src/components/VirtualList/VirtualList.tsx
import { match as match3 } from "ts-pattern";
import { IndigoIndigo50 as IndigoIndigo502 } from "@sequencehq/design-tokens";
import CheckIcon from "@heroicons/react/24/outline/CheckIcon";
import { jsx as jsx10, jsxs as jsxs5 } from "react/jsx-runtime";
var VirtualList = ({
  parentRef,
  menuProps,
  tokens,
  getItemProps,
  highlightedIndex,
  itemToContent,
  styles,
  tokenIsDisabled,
  px,
  getSizeByType: getSizeByType5,
  tokenToOption: tokenToOption2 = tokenToOption,
  currentValueIndex
}) => {
  const { header, body, footer } = groupTokensByLocation(tokens);
  const rowVirtualizer = useVirtualizer({
    count: body.length,
    getScrollElement: () => parentRef.current,
    estimateSize: (index) => getSizeByType5(body[index]),
    overscan: 5,
    getItemKey: getItemKey(body)
  });
  const virtualRows = rowVirtualizer.getVirtualItems();
  const paddingTop = virtualRows.length > 0 ? virtualRows?.[0]?.start || 0 : 0;
  const paddingBottom = virtualRows.length > 0 ? rowVirtualizer.getTotalSize() - (virtualRows?.[virtualRows.length - 1]?.end || 0) : 0;
  return /* @__PURE__ */ jsx10(Box2, { ...menuProps, margin: "8px", children: /* @__PURE__ */ jsxs5(Box2, { children: [
    /* @__PURE__ */ jsx10(List, { children: header.map((token, index) => /* @__PURE__ */ jsx10(
      TokenItem,
      {
        token,
        tokenIsDisabled,
        highlightedIndex,
        getItemProps,
        itemToContent,
        styles,
        px,
        getSizeByType: getSizeByType5,
        tokenToOption: tokenToOption2
      },
      getItemKey(header)(index)
    )) }),
    /* @__PURE__ */ jsx10(
      Box2,
      {
        ref: parentRef,
        overflowY: "auto",
        maxHeight: "200px",
        position: "relative",
        children: /* @__PURE__ */ jsxs5(List, { height: `${rowVirtualizer.getTotalSize()}px`, children: [
          paddingTop > 0 && /* @__PURE__ */ jsx10("li", { style: { height: `${paddingTop}px` } }),
          virtualRows.map(({ key, index, size }) => /* @__PURE__ */ jsx10(
            TokenItem,
            {
              token: body[index],
              tokenIsDisabled,
              highlightedIndex,
              getItemProps,
              itemToContent,
              styles,
              size,
              px,
              getSizeByType: getSizeByType5,
              tokenToOption: tokenToOption2,
              currentValueIndex
            },
            key
          )),
          paddingBottom > 0 && /* @__PURE__ */ jsx10(
            "li",
            {
              style: { height: `${paddingBottom}px`, marginBottom: "8px" }
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ jsx10(List, { children: footer.map((token, index) => /* @__PURE__ */ jsx10(
      TokenItem,
      {
        token,
        tokenIsDisabled,
        highlightedIndex,
        getItemProps,
        itemToContent,
        styles,
        px,
        getSizeByType: getSizeByType5,
        tokenToOption: tokenToOption2
      },
      getItemKey(footer)(index)
    )) })
  ] }) });
};
var TokenItem = ({
  token,
  tokenIsDisabled,
  highlightedIndex,
  getItemProps,
  itemToContent,
  styles,
  size,
  px,
  getSizeByType: getSizeByType5,
  tokenToOption: tokenToOption2,
  currentValueIndex
}) => {
  const disabled = (token.type === "divider" || token.type === "title" || tokenIsDisabled?.(token)) ?? false;
  const highLighted = highlightedIndex === token.tokenIndex;
  const selectedValue = currentValueIndex === token.tokenIndex;
  return /* @__PURE__ */ jsxs5(
    ListItem,
    {
      display: selectedValue ? "flex" : void 0,
      justifyContent: selectedValue ? "space-between" : void 0,
      height: `${size ?? getSizeByType5(token)}px`,
      opacity: disabled && token.type !== "divider" ? 0.4 : 1,
      ...getItemProps({
        item: token,
        index: token.tokenIndex,
        disabled
      }),
      ...styles.item,
      backgroundColor: highLighted ? standardHoverBackground2 : "white",
      borderRadius: token.type !== "divider" ? "6px" : "0",
      color: selectedValue ? IndigoIndigo502 : void 0,
      _notLast: {
        marginBottom: "4px"
      },
      children: [
        tokenToOption2({ token, itemToContent, px, selectedValue }),
        selectedValue ? /* @__PURE__ */ jsx10(Box2, { paddingRight: "16px", children: /* @__PURE__ */ jsx10(
          Icon,
          {
            as: CheckIcon,
            width: "16px",
            height: "16px",
            color: IndigoIndigo502
          }
        ) }) : null
      ]
    }
  );
};
var groupTokensByLocation = (tokens) => {
  return tokens.reduce(
    (acc, item, tokenIndex) => {
      return match3(item.location).with("header", () => {
        acc.header.push({ ...item, tokenIndex });
        return acc;
      }).with("body", () => {
        acc.body.push({ ...item, tokenIndex });
        return acc;
      }).with("footer", () => {
        acc.footer.push({ ...item, tokenIndex });
        return acc;
      }).exhaustive();
    },
    {
      header: [],
      body: [],
      footer: []
    }
  );
};
var getItemKey = (tokens) => (index) => {
  const key = match3(tokens[index]).with({ type: "model" }, (matched) => matched.model.id).with({ type: "divider" }, () => "divider").with({ type: "button" }, (matched) => matched.key).with({ type: "title" }, (matched) => matched.title).exhaustive();
  return key;
};

// src/components/CompoundInputs/util.ts
var getSelectedItem = ({
  items,
  value,
  idValue
}) => {
  const found = items.find((item) => item.id === idValue);
  if (!value) {
    return found ? { type: "model", location: "body", model: found } : null;
  } else {
    return { type: "model", location: "body", model: value };
  }
};
var modelToToken = (model) => ({
  type: "model",
  location: "body",
  model
});

// src/components/CompoundInputs/CustomSelectNew.tsx
import { match as match4 } from "ts-pattern";
import { Plus } from "react-feather";
import { jsx as jsx11, jsxs as jsxs6 } from "react/jsx-runtime";
var CustomSelectNew = ({
  placeholder,
  items,
  itemToString,
  itemToContent,
  tokenIsDisabled,
  disabled,
  rightIcon,
  onChange,
  width,
  height,
  isInvalid,
  border,
  borderRadius,
  addNewAction,
  postChange,
  model,
  value,
  modelLookup
}) => {
  const supplementedItems = items.map(modelToToken);
  if (addNewAction) {
    supplementedItems.push({ type: "divider", location: "footer" });
    supplementedItems.push({
      key: "add-new-button",
      type: "button",
      leftIcon: /* @__PURE__ */ jsx11(Plus, {}),
      label: "Create new",
      location: "footer",
      onClick: addNewAction
    });
  }
  const actualModel = model === void 0 && modelLookup ? modelLookup(value) : model ?? null;
  const {
    isOpen,
    selectedItem,
    getToggleButtonProps,
    getMenuProps,
    getItemProps,
    highlightedIndex
  } = useSelect({
    items: supplementedItems,
    itemToString: (token) => {
      return token?.type === "model" ? itemToString(token.model) : "";
    },
    onSelectedItemChange: ({ selectedItem: selectedValue }) => {
      if (!selectedValue || selectedValue?.type === "model") {
        onChange(selectedValue?.type === "model" ? selectedValue.model.id : "");
        postChange?.();
      }
    },
    selectedItem: actualModel ? modelToToken(actualModel) : null
  });
  const parentRef = useRef(null);
  const controlRef = useRef(null);
  const styles = useMultiStyleConfig3("CustomSelect");
  return /* @__PURE__ */ jsx11(Popover2, { isOpen, autoFocus: false, variant: "downshift", children: /* @__PURE__ */ jsxs6(Box3, { ref: controlRef, width, position: "relative", cursor: "pointer", children: [
    /* @__PURE__ */ jsx11(PopoverAnchor, { children: /* @__PURE__ */ jsxs6(
      Flex3,
      {
        alignItems: "center",
        position: "relative",
        outline: "none",
        ...styles.toggleButton,
        _focus: {
          borderColor: IndigoIndigo503,
          boxShadow: focusedBoxShadow
        },
        ...isInvalid && {
          borderColor: RedRed60,
          boxShadow: errorBoxShadow
        },
        ...getToggleButtonProps({ disabled }),
        tabIndex: disabled ? void 0 : 0,
        py: 3,
        border: border || standardBorder,
        borderRadius,
        height,
        children: [
          rightIcon,
          /* @__PURE__ */ jsx11(
            Box3,
            {
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflowX: "auto",
              overflowY: "hidden",
              pl: 1,
              pr: 6,
              children: selectedItem?.type === "model" ? itemToString(selectedItem.model) : placeholder
            }
          ),
          /* @__PURE__ */ jsx11(SelectIcon, { __css: styles.icon, children: isOpen ? /* @__PURE__ */ jsx11(ChevronUpIcon, {}) : /* @__PURE__ */ jsx11(ChevronDownIcon, {}) })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx11(Portal2, { children: /* @__PURE__ */ jsx11(PopoverContent2, { width: controlRef.current?.offsetWidth, children: /* @__PURE__ */ jsx11(PopoverBody2, { children: /* @__PURE__ */ jsx11(
      VirtualList,
      {
        parentRef,
        menuProps: { ...getMenuProps({}, { suppressRefError: true }) },
        tokens: supplementedItems,
        getItemProps,
        highlightedIndex,
        itemToContent,
        styles,
        tokenIsDisabled,
        getSizeByType
      }
    ) }) }) })
  ] }) });
};
var getSizeByType = (item) => {
  return match4(item.type).with("divider", () => 17).otherwise(() => 40);
};

// src/components/CompoundInputs/ComboInputRemoteFilterNew.tsx
import { useCombobox } from "downshift";
import {
  useMultiStyleConfig as useMultiStyleConfig4,
  Box as Box4,
  Popover as Popover3,
  PopoverAnchor as PopoverAnchor2,
  PopoverContent as PopoverContent3,
  PopoverBody as PopoverBody3,
  Input as ChakraInput,
  InputGroup,
  Portal as Portal3,
  InputRightElement
} from "@chakra-ui/react";
import { useRef as useRef2 } from "react";
import { ChevronDownIcon as ChevronDownIcon2, ChevronUpIcon as ChevronUpIcon2 } from "@chakra-ui/icons";
import { borderColor } from "@sequencehq/core-theme";
import { RedRed60 as RedRed602, IndigoIndigo50 as IndigoIndigo504 } from "@sequencehq/design-tokens";
import { Plus as Plus2 } from "react-feather";
import { match as match5 } from "ts-pattern";
import { dequal } from "dequal";
import { jsx as jsx12, jsxs as jsxs7 } from "react/jsx-runtime";
var getSupplementedItems = (filteredItems, hasFilter, addNewAction) => {
  const items = [];
  if (!hasFilter && items.length) {
    items.push({
      type: "title",
      location: "header",
      title: "Recent"
    });
  }
  items.push(
    ...filteredItems.map((item) => ({
      type: "model",
      location: "body",
      model: item
    }))
  );
  if (addNewAction) {
    if (filteredItems.length) {
      items.push({ type: "divider", location: "footer" });
    }
    items.push({
      key: "add-new",
      type: "button",
      leftIcon: /* @__PURE__ */ jsx12(Plus2, {}),
      label: "Create new",
      location: "footer",
      onClick: addNewAction
    });
  }
  return items;
};
var ComboInputRemoteFilterNew = ({
  fieldLabel,
  placeholder,
  items,
  itemToString,
  itemToContent,
  disabled,
  onChange,
  width,
  isInvalid,
  setQuery,
  query,
  tokenIsDisabled,
  addNewAction,
  inputRef,
  handleBlur,
  model,
  postChange
}) => {
  const groupRef = useRef2(null);
  const tokens = getSupplementedItems(
    items,
    Boolean(query),
    addNewAction
  );
  const {
    isOpen,
    getToggleButtonProps,
    getMenuProps,
    getItemProps,
    getInputProps,
    highlightedIndex
  } = useCombobox({
    items: tokens,
    selectedItemChanged: (prev, next) => !dequal(prev, next),
    itemToString: (token) => {
      return token?.type === "model" ? itemToString(token.model) : "";
    },
    selectedItem: model ? modelToToken(model) : null,
    onSelectedItemChange: ({ selectedItem: selectedValue }) => {
      if (selectedValue?.type === "model") {
        onChange(selectedValue.model.id);
        postChange?.();
      }
    },
    inputValue: query,
    onInputValueChange: (props) => {
      if (setQuery && // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
      props.type !== "__controlled_prop_updated_selected_item__") {
        setQuery(props.inputValue ?? "");
      }
    }
  });
  const parentRef = useRef2(null);
  const controlRef = useRef2(null);
  const styles = useMultiStyleConfig4("CustomSelect");
  return /* @__PURE__ */ jsx12(Popover3, { isOpen, autoFocus: false, variant: "downshift", children: /* @__PURE__ */ jsxs7(Box4, { ref: controlRef, width, position: "relative", children: [
    /* @__PURE__ */ jsx12(Label, { children: fieldLabel }),
    /* @__PURE__ */ jsx12(PopoverAnchor2, { children: /* @__PURE__ */ jsxs7(
      InputGroup,
      {
        ref: groupRef,
        width,
        alignItems: "center",
        position: "relative",
        outline: "2px solid",
        p: 0,
        onBlur: (event) => {
          const contained = groupRef.current?.contains(event.relatedTarget);
          if (handleBlur && !contained) {
            handleBlur();
          }
        },
        _focusWithin: {
          outlineColor: IndigoIndigo504,
          borderColor: "transparent"
        },
        __css: styles.toggleButton,
        ...{
          borderColor: isInvalid ? "transparent" : borderColor,
          outlineColor: isInvalid ? RedRed602 : "transparent"
        },
        tabIndex: disabled ? void 0 : 0,
        children: [
          /* @__PURE__ */ jsx12(
            ChakraInput,
            {
              variant: "plain",
              disabled,
              placeholder,
              p: 3,
              ...getInputProps({
                ref: inputRef
              })
            }
          ),
          /* @__PURE__ */ jsx12(
            InputRightElement,
            {
              ...getToggleButtonProps({ disabled }),
              height: "40px",
              width: "24px",
              right: "8px",
              cursor: "pointer",
              children: isOpen ? /* @__PURE__ */ jsx12(ChevronUpIcon2, { width: "20px", height: "20px" }) : /* @__PURE__ */ jsx12(ChevronDownIcon2, { width: "20px", height: "20px" })
            }
          )
        ]
      }
    ) }),
    tokens?.length > 0 && /* @__PURE__ */ jsx12(Portal3, { children: /* @__PURE__ */ jsx12(PopoverContent3, { width: controlRef.current?.offsetWidth, children: /* @__PURE__ */ jsx12(PopoverBody3, { children: /* @__PURE__ */ jsx12(
      VirtualList,
      {
        parentRef,
        menuProps: {
          ...getMenuProps({}, { suppressRefError: true })
        },
        tokens,
        getItemProps,
        tokenIsDisabled,
        highlightedIndex,
        itemToContent,
        styles,
        getSizeByType: getSizeByType2
      }
    ) }) }) })
  ] }) });
};
var getSizeByType2 = (item) => {
  return match5(item.type).with("divider", () => 17).otherwise(() => 40);
};

// src/components/Fields/createFormField.tsx
import {
  Box as Box5,
  Flex as Flex4,
  FormControl as FormControl2,
  FormErrorMessage as FormErrorMessage2,
  FormHelperText as FormHelperText2,
  Text as Text3
} from "@chakra-ui/react";
import { Field as Field2 } from "react-final-form";
import { Fragment as Fragment2, jsx as jsx13, jsxs as jsxs8 } from "react/jsx-runtime";
var InputContextLabel = ({ label, children }) => {
  return label ? /* @__PURE__ */ jsxs8(Flex4, { alignItems: "flex-end", justifyContent: "flex-start", children: [
    children,
    /* @__PURE__ */ jsx13(Box5, { width: 4 }),
    /* @__PURE__ */ jsx13(
      Text3,
      {
        height: 10,
        alignItems: "center",
        fontSize: 16,
        display: "flex",
        whiteSpace: "nowrap",
        flex: "1",
        children: label
      }
    )
  ] }) : /* @__PURE__ */ jsx13(Fragment2, { children });
};
var createFormField = (InputComponent, labelAbove = true) => (props) => {
  const {
    fieldName,
    fieldLabel,
    validate,
    tabIndex = 0,
    parse,
    isOptional,
    format: format2,
    formHelperText,
    contextLabel,
    controlWidth,
    hidden,
    infoPopover,
    defaultValue,
    isEqual,
    autoComplete = "off",
    onExternalChange,
    ...rest
  } = props;
  const inputProps = rest;
  const ignorePasswordManager = autoComplete === "off";
  return /* @__PURE__ */ jsx13(
    Field2,
    {
      name: fieldName,
      validate,
      parse,
      format: format2,
      isEqual,
      defaultValue,
      children: ({ input, meta }) => {
        const errorMessage = meta.error ?? meta.submitError;
        return /* @__PURE__ */ jsxs8(
          FormControl2,
          {
            isInvalid: errorMessage && meta.touched,
            width: controlWidth,
            display: hidden ? "none" : "block",
            children: [
              /* @__PURE__ */ jsxs8(Flex4, { flexDirection: labelAbove ? "column" : "row", children: [
                /* @__PURE__ */ jsx13(Label, { infoPopover, isOptional, children: fieldLabel }),
                /* @__PURE__ */ jsx13(InputContextLabel, { label: contextLabel, children: /* @__PURE__ */ jsx13(
                  InputComponent,
                  {
                    ...errorMessage && meta.touched ? { isInvalid: true } : {},
                    name: fieldName,
                    tabIndex,
                    ...inputProps,
                    value: input.value,
                    onChange: input.onChange,
                    autoComplete,
                    "data-1p-ignore": ignorePasswordManager,
                    "data-lpignore": ignorePasswordManager
                  }
                ) })
              ] }),
              /* @__PURE__ */ jsx13(
                SubText,
                {
                  formHelperText,
                  errorMessage,
                  value: input.value
                }
              ),
              onExternalChange ? onExternalChange(input) : null
            ]
          }
        );
      }
    }
  );
};
var SubText = ({
  formHelperText,
  errorMessage,
  value
}) => {
  if (errorMessage) {
    return /* @__PURE__ */ jsx13(FormErrors, { formError: errorMessage, as: FormErrorMessage2 });
  }
  if (typeof formHelperText === "string") {
    return /* @__PURE__ */ jsx13(FormHelperText2, { children: formHelperText });
  }
  if (value && typeof formHelperText === "function") {
    const text = formHelperText(value);
    return text ? /* @__PURE__ */ jsx13(FormHelperText2, { children: text }) : null;
  }
  return null;
};

// src/components/Inputs/Checkbox.tsx
import {
  Checkbox as ChakraCheckbox
} from "@chakra-ui/react";
import { jsx as jsx14 } from "react/jsx-runtime";
var Checkbox = ({
  value,
  onChange,
  disabled,
  ...props
}) => /* @__PURE__ */ jsx14(
  ChakraCheckbox,
  {
    ...props,
    isChecked: value,
    onChange: (event) => onChange(event.target.checked),
    disabled
  }
);

// src/components/Inputs/Input.tsx
import {
  Input as ChakraInput2,
  InputGroup as InputGroup2,
  InputLeftAddon,
  InputLeftElement,
  InputRightAddon,
  InputRightElement as InputRightElement2
} from "@chakra-ui/react";
import {
  borderColor as borderColor2,
  errorBoxShadow as errorBoxShadow2,
  focusedBoxShadow as focusedBoxShadow2,
  inputBorderRadius,
  standardBorder as standardBorder2
} from "@sequencehq/core-theme";
import { RedRed60 as RedRed603, IndigoIndigo50 as IndigoIndigo505 } from "@sequencehq/design-tokens";
import { jsx as jsx15, jsxs as jsxs9 } from "react/jsx-runtime";
var Input = ({
  leftAddon,
  rightAddon,
  leftElement,
  rightElement,
  width,
  inputRef,
  isInvalid,
  "data-testid": dataTestId,
  ...props
}) => /* @__PURE__ */ jsxs9(
  InputGroup2,
  {
    width,
    variant: "input-in-group",
    role: "group",
    border: standardBorder2,
    borderColor: isInvalid ? RedRed603 : borderColor2,
    borderRadius: inputBorderRadius,
    ...isInvalid ? { boxShadow: errorBoxShadow2 } : {},
    _focusWithin: {
      borderColor: IndigoIndigo505,
      boxShadow: focusedBoxShadow2
    },
    children: [
      leftAddon && /* @__PURE__ */ jsx15(InputLeftAddon, { borderRight: standardBorder2, children: leftAddon }),
      leftElement && /* @__PURE__ */ jsx15(InputLeftElement, { children: leftElement }),
      /* @__PURE__ */ jsx15(
        ChakraInput2,
        {
          ref: inputRef,
          ...props,
          variant: "input-in-group",
          ...leftAddon ? { borderLeft: standardBorder2 } : {},
          ...rightAddon ? { borderRight: standardBorder2 } : {},
          "data-testid": dataTestId,
          "data-1p-ignore": "true",
          "data-lpignore": "true"
        }
      ),
      rightAddon && /* @__PURE__ */ jsx15(InputRightAddon, { borderLeft: standardBorder2, children: rightAddon }),
      rightElement && /* @__PURE__ */ jsx15(InputRightElement2, { children: rightElement })
    ]
  }
);

// src/components/Inputs/CalendarHeader.tsx
import { Button as Button2, Flex as Flex5, Spacer, Tooltip, Text as Text4 } from "@chakra-ui/react";
import { ChevronRightIcon, ChevronLeftIcon } from "@chakra-ui/icons";
import { jsx as jsx16, jsxs as jsxs10 } from "react/jsx-runtime";
var DateSkipperButton = ({
  calendar,
  directionProps,
  offset,
  children,
  type
}) => {
  const tooltipLabel = offset === 1 && type === "back" ? "Previous month" : offset === 1 && type === "forward" ? "Next month" : offset === 12 && type === "back" ? "Previous year" : offset === 12 && type === "forward" ? "Next year" : "";
  return /* @__PURE__ */ jsx16(
    Tooltip,
    {
      label: tooltipLabel,
      placement: "top",
      isDisabled: !tooltipLabel ? true : false,
      hasArrow: true,
      bg: "#171923",
      color: "white",
      px: "8px",
      py: "4px",
      fontSize: "14px",
      fontWeight: "400",
      borderRadius: "4px",
      children: /* @__PURE__ */ jsx16(
        Button2,
        {
          ...directionProps({
            calendars: [calendar],
            offset
          }),
          tabIndex: -1,
          variant: "dateSkipper",
          width: "24px",
          height: "24px",
          children
        }
      )
    }
  );
};
var CalendarHeader = ({
  getBackProps,
  getForwardProps,
  calendar,
  monthLabel,
  hideYearSkippers
}) => {
  return /* @__PURE__ */ jsxs10(Flex5, { w: "100%", children: [
    !hideYearSkippers && /* @__PURE__ */ jsxs10(
      DateSkipperButton,
      {
        calendar,
        directionProps: getBackProps,
        offset: 12,
        type: "back",
        children: [
          /* @__PURE__ */ jsx16(ChevronLeftIcon, {}),
          /* @__PURE__ */ jsx16(ChevronLeftIcon, {})
        ]
      }
    ),
    /* @__PURE__ */ jsx16(
      DateSkipperButton,
      {
        calendar,
        directionProps: getBackProps,
        offset: 1,
        type: "back",
        children: /* @__PURE__ */ jsx16(ChevronLeftIcon, {})
      }
    ),
    /* @__PURE__ */ jsx16(Spacer, {}),
    /* @__PURE__ */ jsx16(Flex5, { justify: "center", align: "center", children: /* @__PURE__ */ jsx16(Text4, { fontWeight: 700, children: monthLabel }) }),
    /* @__PURE__ */ jsx16(Spacer, {}),
    /* @__PURE__ */ jsx16(
      DateSkipperButton,
      {
        calendar,
        directionProps: getForwardProps,
        offset: 1,
        type: "forward",
        children: /* @__PURE__ */ jsx16(ChevronRightIcon, {})
      }
    ),
    !hideYearSkippers && /* @__PURE__ */ jsxs10(
      DateSkipperButton,
      {
        calendar,
        directionProps: getForwardProps,
        offset: 12,
        type: "forward",
        children: [
          /* @__PURE__ */ jsx16(ChevronRightIcon, {}),
          /* @__PURE__ */ jsx16(ChevronRightIcon, {})
        ]
      }
    )
  ] });
};

// src/components/Inputs/CalendarView.tsx
import { monthNamesShort, weekdayNamesShort } from "@sequencehq/core-models";
import { Box as Box6, Flex as Flex6, SimpleGrid, Text as Text5 } from "@chakra-ui/react";

// src/components/Inputs/DateButton.tsx
import { Button as Button3 } from "@chakra-ui/react";
import { match as match6 } from "ts-pattern";
import { IndigoIndigo50 as IndigoIndigo506, TurquoiseTurquoise80 } from "@sequencehq/design-tokens";
import { jsx as jsx17 } from "react/jsx-runtime";
var getKeyOffset = (number) => {
  const e = document.activeElement;
  const buttons = document.querySelectorAll("button.date-button");
  buttons.forEach((el, i) => {
    const newNodeKey = i + number;
    if (el == e) {
      if (newNodeKey <= buttons.length - 1 && newNodeKey >= 0) {
        buttons[newNodeKey].focus();
      } else {
        buttons[0].focus();
      }
    }
  });
};
var DateButton = ({
  selected,
  today,
  dateProps,
  inRange,
  selectableDate,
  label,
  position,
  initialRef,
  hasInitialFocus: hasInitialFocus2,
  focusedInput
}) => {
  const styles = dateStyling({
    today,
    selected,
    selectable: selectableDate,
    inRange,
    position
  });
  return /* @__PURE__ */ jsx17(
    Button3,
    {
      ...dateProps,
      ...styles,
      className: "date-button",
      ref: hasInitialFocus2 ? initialRef : null,
      tabIndex: -1,
      isDisabled: !selectableDate,
      _focus: {
        zIndex: 1,
        boxShadow: `0 0 0 2px ${IndigoIndigo506}`,
        borderRadius: match6(focusedInput).with("start", () => "8px 0 0 8px").with("end", () => "0 8px 8px 0").otherwise(() => "8px")
      },
      onKeyDown: (event) => {
        match6(event.key).with("ArrowUp", () => {
          event.preventDefault();
          getKeyOffset(-7);
        }).with("ArrowRight", () => {
          event.preventDefault();
          return getKeyOffset(1);
        }).with("ArrowLeft", () => {
          event.preventDefault();
          return getKeyOffset(-1);
        }).with("ArrowDown", () => {
          event.preventDefault();
          return getKeyOffset(7);
        }).otherwise(() => {
        });
      },
      children: label
    }
  );
};
var dateStyling = ({
  today,
  selected,
  selectable,
  inRange,
  position
}) => {
  const styles = {};
  styles.border = "1px solid";
  styles.bg = "white";
  styles.borderColor = "white";
  styles.fontWeight = "400";
  styles.fontSize = "14px";
  styles.lineHeight = "16px";
  styles.width = "40px";
  styles.height = "40px";
  styles.borderRadius = "0";
  styles._hover = {};
  if (today) {
    styles.borderRadius = "8px";
  }
  if (selectable) {
    if (selected) {
      styles.bg = TurquoiseTurquoise80;
      styles.borderColor = TurquoiseTurquoise80;
      styles.color = "white";
      if (position === "start") {
        styles.borderRadius = "8px 0 0 8px";
      } else if (position === "end") {
        styles.borderRadius = "0 8px 8px 0";
      } else {
        styles.borderRadius = "8px";
      }
    } else if (inRange) {
      styles.bg = "gray.20";
      styles.borderColor = "gray.20";
    } else {
      styles.color = "gray.100";
      styles._hover = {
        bg: "gray.20",
        borderColor: "gray.20"
      };
    }
  }
  if (today) {
    styles.borderColor = TurquoiseTurquoise80;
  }
  return styles;
};

// src/components/Inputs/CalendarView.tsx
import { match as match7 } from "ts-pattern";

// ../validation/dist/index.js
var import_inflection = __toESM(require_inflection(), 1);
var EMAIL_PATTERN = (
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);
var required = (value) => {
  if (Array.isArray(value) && value.length === 0) {
    return "This field is required";
  }
  return value ? void 0 : "This field is required";
};
var isValidDate = (date) => {
  if (!(date instanceof Date)) {
    return false;
  }
  try {
    if (date.toString() === "Invalid Date") {
      return false;
    }
  } catch (_e) {
    return false;
  }
  return true;
};

// src/components/Inputs/getToday.ts
var getToday = () => {
  const now = /* @__PURE__ */ new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return today;
};

// src/components/Inputs/CalendarView.tsx
import { add, format } from "@sequencehq/utils/dates";
import { jsx as jsx18, jsxs as jsxs11 } from "react/jsx-runtime";
var CalendarView = ({
  calendar,
  getDateProps,
  getBackProps,
  getForwardProps,
  initialRef,
  ...rest
}) => /* @__PURE__ */ jsxs11(Flex6, { flexDirection: "column", width: "max-content", children: [
  /* @__PURE__ */ jsx18(
    CalendarHeader,
    {
      getForwardProps,
      getBackProps,
      calendar,
      monthLabel: `${monthNamesShort[calendar.month]} ${calendar.year}`
    }
  ),
  /* @__PURE__ */ jsxs11(SimpleGrid, { columns: 7, spacingY: "1px", textAlign: "center", children: [
    weekdayNamesShort.map((weekday) => /* @__PURE__ */ jsx18(
      Text5,
      {
        color: "gray.60",
        fontSize: "12px",
        lineHeight: "16px",
        py: 4,
        children: weekday
      },
      weekday
    )),
    calendar.weeks.map(
      (week) => week.map((dateObj, index) => {
        if (typeof dateObj === "string") {
          return /* @__PURE__ */ jsx18(Box6, { outline: "none" }, index);
        }
        const { date, selectable, selected, today } = dateObj;
        return /* @__PURE__ */ jsx18(
          DateButton,
          {
            initialRef,
            selected,
            selectableDate: selectable,
            today,
            label: dateObj.date.getDate(),
            dateProps: {
              ...getDateProps({
                dateObj
              })
            },
            ...getRangeProps({
              ...rest,
              date,
              selected,
              today
            })
          },
          format(date, "yyyy-MM-dd")
        );
      })
    )
  ] })
] });
var getRangeProps = ({ selected, date, today, ...rest }) => {
  if (rest.type === "single") {
    return;
  }
  const { selectedDates, focusedInput } = rest;
  return {
    position: getPosition({ selected, date, selectedDates }),
    hasInitialFocus: hasInitialFocus({
      today,
      date,
      selectedDates,
      focusedInput
    }),
    inRange: Boolean(isInRange({ date, selectedDates })),
    focusedInput
  };
};
var getPosition = ({
  selected,
  date,
  selectedDates
}) => {
  if (!selected) {
    return void 0;
  }
  if (isValidDate(selectedDates[0]) && isValidDate(selectedDates[1]) && date.getTime() === selectedDates[0].getTime()) {
    return "start";
  }
  if (isValidDate(selectedDates[0]) && isValidDate(selectedDates[1]) && date.getTime() === selectedDates[1].getTime()) {
    return "end";
  }
};
var isInRange = ({ date, selectedDates }) => {
  if (!isValidDate(selectedDates[0]) || !isValidDate(selectedDates[1])) {
    return false;
  }
  const firstSelected = selectedDates[0]?.getTime();
  const secondSelected = selectedDates[1]?.getTime();
  return firstSelected && secondSelected && firstSelected < date.getTime() && secondSelected > date.getTime();
};
var hasInitialFocus = ({
  today,
  date,
  selectedDates,
  focusedInput
}) => {
  return match7(focusedInput).with("start", () => {
    if (selectedDates[0] && isValidDate(selectedDates[0])) {
      return date.getTime() === selectedDates[0].getTime();
    } else if (selectedDates[1] && isValidDate(selectedDates[1])) {
      return date.getTime() === add(selectedDates[1], { days: -1 }).getTime();
    } else {
      return today;
    }
  }).with("end", () => {
    if (selectedDates[1] && isValidDate(selectedDates[1])) {
      return date.getTime() === selectedDates[1].getTime();
    } else if (selectedDates[0] && isValidDate(selectedDates[0])) {
      return date.getTime() === add(selectedDates[0], { days: 0 }).getTime();
    } else {
      return date.getTime() === getToday().getTime();
    }
  }).otherwise(() => false);
};

// src/components/Fields/FixedField.ts
import { useEffect as useEffect2 } from "react";
import { useField } from "react-final-form";
var FixedField = ({
  fieldName,
  value
}) => {
  const { input } = useField(fieldName);
  useEffect2(() => input.onChange(value), [input, value]);
  return null;
};

// src/components/Fields/index.ts
var TextInputField = createFormField(Input);
var CheckboxField = createFormField(Checkbox);

// src/components/MultiTagField/MultiTagField.tsx
import { useEffect as useEffect3, useLayoutEffect, useRef as useRef3, useState } from "react";
import { Badge } from "@sequencehq/core-components";

// src/components/InputGroup/InputGroup.tsx
import {
  InputGroup as ChakraInputGroup
} from "@chakra-ui/react";
import { RedRed60 as RedRed604, IndigoIndigo50 as IndigoIndigo507 } from "@sequencehq/design-tokens";
import { borderColor as borderColor3 } from "@sequencehq/core-theme";
import { jsx as jsx19 } from "react/jsx-runtime";
var InputGroup3 = ({
  children,
  groupRef,
  isInvalid,
  ...props
}) => /* @__PURE__ */ jsx19(
  ChakraInputGroup,
  {
    ref: groupRef,
    borderRadius: "6px",
    border: "1px solid",
    outline: "2px solid",
    borderColor: isInvalid ? "transparent" : borderColor3,
    outlineColor: isInvalid ? RedRed604 : "transparent",
    _focusWithin: {
      outlineColor: IndigoIndigo507,
      borderColor: "transparent"
    },
    display: "flex",
    alignItems: "center",
    position: "relative",
    p: 2,
    tabIndex: props.disabled ? void 0 : 0,
    ...props,
    children
  }
);

// src/components/MultiTagField/MultiTagField.tsx
import { FieldArray } from "react-final-form-arrays";
import { Input as ChakraInput3, usePrevious } from "@chakra-ui/react";
import { Lato14Regular } from "@sequencehq/design-tokens";
import { Fragment as Fragment3, jsx as jsx20 } from "react/jsx-runtime";
var DELIMITERS = /[\s,;]+/;
var MultiTagInput = ({
  name,
  value: values,
  validateItem,
  isInvalid
}) => {
  const inputRef = useRef3(null);
  const inputValues = values || [""];
  const previous = usePrevious(values);
  const [containsFocus, setContainsFocus] = useState(false);
  useEffect3(() => {
    if (!previous || !containsFocus) {
      return;
    }
    if (values.length !== previous.length) {
      inputRef.current?.focus();
    }
  }, [values, previous, containsFocus]);
  return /* @__PURE__ */ jsx20(
    InputGroup3,
    {
      gap: "8px",
      px: "12px",
      flexWrap: "wrap",
      onFocus: () => {
        inputRef.current?.focus();
        setContainsFocus(true);
      },
      onBlur: () => setContainsFocus(false),
      isInvalid,
      children: /* @__PURE__ */ jsx20(FieldArray, { name, children: ({ fields }) => /* @__PURE__ */ jsx20(Fragment3, { children: inputValues.map((value, index) => {
        if (index === inputValues.length - 1) {
          return /* @__PURE__ */ jsx20(
            TagInput,
            {
              value,
              validateItem,
              inputRef,
              index,
              push: fields.push,
              update: fields.update
            },
            `input-${index}`
          );
        }
        return /* @__PURE__ */ jsx20(
          Badge,
          {
            sentiment: "monospaced",
            textTransform: "none",
            size: "md",
            onDelete: () => fields.remove(index),
            children: value
          },
          `badge-${value}-${index}`
        );
      }) }) })
    }
  );
};
var MultiTagField = createFormField(MultiTagInput);
var TagInput = ({
  value,
  inputRef,
  validateItem,
  push,
  update,
  index = 0
}) => {
  const [textWidth, setTextWidth] = useState();
  useLayoutEffect(() => {
    setTextWidth(measureTextWidth(value));
  }, [value]);
  return /* @__PURE__ */ jsx20(
    ChakraInput3,
    {
      ref: inputRef,
      variant: "plain",
      p: 0,
      ...Lato14Regular,
      onChange: (event) => {
        handleChange({
          value: event.target.value,
          validateItem,
          force: false,
          push,
          update,
          index
        });
      },
      height: "20px",
      minHeight: "28px",
      value,
      onKeyDown: (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          handleChange({
            value,
            validateItem,
            force: true,
            push,
            update,
            index
          });
        }
      },
      width: textWidth ? `${textWidth + 24}px` : "30px"
    }
  );
};
var handleChange = ({
  value,
  index,
  validateItem,
  force,
  push,
  update
}) => {
  const { valid, invalid } = chunkValue({
    value,
    validateItem,
    force
  });
  const items = [...valid, invalid];
  const firstItem = items.shift();
  if (firstItem === void 0) {
    return;
  }
  update(index, firstItem);
  items.forEach((item) => push(item));
};
var measureTextWidth = (text) => {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  if (!context) {
    return void 0;
  }
  context.font = "16px Lato";
  const { width } = context.measureText(text);
  return width;
};
var chunkValue = ({ value, validateItem, force }) => {
  const items = value.split(DELIMITERS);
  if (items.length === 1 && !force) {
    return {
      valid: [],
      invalid: value
    };
  }
  const { valid, invalid } = items.reduce(
    (acc, item) => {
      const validated = !validateItem({
        value: item
      });
      if (validated) {
        acc.valid.push(item);
      } else {
        acc.invalid.push(item);
      }
      return acc;
    },
    {
      valid: [],
      invalid: []
    }
  );
  return {
    valid,
    invalid: valid.length ? invalid.join(", ") : value
  };
};

// src/components/MultiTagField/validateEmailItem.ts
var validateEmailItem = ({ value }) => {
  if (!EMAIL_PATTERN.test(value)) {
    return "Value is not an email address";
  }
};

// src/components/Recurrence/Recurrence.tsx
import { useState as useState2, useRef as useRef4 } from "react";
import {
  Popover as Popover4,
  PopoverBody as PopoverBody4,
  PopoverContent as PopoverContent4,
  PopoverAnchor as PopoverAnchor3,
  InputGroup as InputGroup4,
  Input as Input2,
  InputRightElement as InputRightElement3,
  FormControl as FormControl3,
  Flex as Flex8
} from "@chakra-ui/react";

// src/components/Recurrence/MonthlyRecurrence.tsx
import { Box as Box7, SimpleGrid as SimpleGrid2, Flex as Flex7, FormLabel as FormLabel2 } from "@chakra-ui/react";

// src/components/Dates/DateButton.tsx
import { Button as Button4 } from "@chakra-ui/react";
import { match as match8 } from "ts-pattern";
import { TurquoiseTurquoise80 as TurquoiseTurquoise802, IndigoIndigo50 as IndigoIndigo508 } from "@sequencehq/design-tokens";
import { jsx as jsx21 } from "react/jsx-runtime";
var getKeyOffset2 = (number) => {
  const e = document.activeElement;
  const buttons = document.querySelectorAll("button.date-button");
  buttons.forEach((el, i) => {
    const newNodeKey = i + number;
    if (el == e) {
      if (newNodeKey <= buttons.length - 1 && newNodeKey >= 0) {
        buttons[newNodeKey].focus();
      } else {
        buttons[0].focus();
      }
    }
  });
};
var DateButton2 = ({
  selected,
  today,
  dateProps,
  inRange,
  selectableDate,
  label,
  position,
  initialRef,
  hasInitialFocus: hasInitialFocus2,
  focusedInput,
  "data-testid": testId
}) => {
  const styles = dateStyling2({
    today,
    selected,
    selectable: selectableDate,
    inRange,
    position
  });
  return /* @__PURE__ */ jsx21(
    Button4,
    {
      ...dateProps,
      ...styles,
      "data-testid": testId,
      className: "date-button",
      ref: hasInitialFocus2 ? initialRef : null,
      tabIndex: -1,
      isDisabled: !selectableDate,
      _focus: {
        zIndex: 1,
        boxShadow: `0 0 0 2px ${IndigoIndigo508}`,
        borderRadius: match8(focusedInput).with("start", () => "8px 0 0 8px").with("end", () => "0 8px 8px 0").otherwise(() => "8px")
      },
      onKeyDown: (event) => {
        match8(event.key).with("ArrowUp", () => {
          event.preventDefault();
          getKeyOffset2(-7);
        }).with("ArrowRight", () => {
          event.preventDefault();
          return getKeyOffset2(1);
        }).with("ArrowLeft", () => {
          event.preventDefault();
          return getKeyOffset2(-1);
        }).with("ArrowDown", () => {
          event.preventDefault();
          return getKeyOffset2(7);
        }).otherwise(() => {
        });
      },
      children: label
    }
  );
};
var dateStyling2 = ({
  today,
  selected,
  selectable,
  inRange,
  position
}) => {
  const styles = {};
  styles.border = "1px solid";
  styles.bg = "white";
  styles.borderColor = "white";
  styles.fontWeight = "400";
  styles.fontSize = "14px";
  styles.lineHeight = "16px";
  styles.width = "40px";
  styles.height = "40px";
  styles.borderRadius = "0";
  styles._hover = {};
  if (today) {
    styles.borderRadius = "8px";
  }
  if (selectable) {
    if (selected) {
      styles.bg = TurquoiseTurquoise802;
      styles.borderColor = TurquoiseTurquoise802;
      styles.color = "white";
      if (position === "start") {
        styles.borderRadius = "8px 0 0 8px";
      } else if (position === "end") {
        styles.borderRadius = "0 8px 8px 0";
      } else {
        styles.borderRadius = "8px";
      }
    } else if (inRange) {
      styles.bg = "gray.20";
      styles.borderColor = "gray.20";
    } else {
      styles.color = "gray.100";
      styles._hover = {
        bg: "gray.20",
        borderColor: "gray.20"
      };
    }
  }
  if (today) {
    styles.borderColor = TurquoiseTurquoise802;
  }
  return styles;
};

// src/components/Recurrence/MonthlyRecurrence.tsx
import { jsx as jsx22, jsxs as jsxs12 } from "react/jsx-runtime";
var MonthlyPopover = ({
  onChange,
  setIsOpen,
  recurrenceDayOfMonth
}) => /* @__PURE__ */ jsxs12(Flex7, { flexDirection: "column", width: "max-content", children: [
  /* @__PURE__ */ jsx22(FormLabel2, { textAlign: "center", children: "Choose a day of the month" }),
  /* @__PURE__ */ jsx22(Box7, { height: 4 }),
  /* @__PURE__ */ jsx22(SimpleGrid2, { columns: 7, spacing: "1px", textAlign: "center", children: Array.from(Array(31), (_, index) => /* @__PURE__ */ jsx22(
    DateButton2,
    {
      "data-testid": `day-${index + 1}`,
      selected: recurrenceDayOfMonth === index + 1,
      label: index + 1,
      today: false,
      selectableDate: true,
      dateProps: {
        onClick: (event) => {
          event.preventDefault();
          onChange(index + 1);
          setIsOpen(false);
        }
      }
    },
    index
  )) })
] });

// src/components/Recurrence/Recurrence.tsx
import { RedRed60 as RedRed605, IndigoIndigo50 as IndigoIndigo509 } from "@sequencehq/design-tokens";
import { ChevronDownIcon as ChevronDownIcon3, ChevronUpIcon as ChevronUpIcon3 } from "@chakra-ui/icons";
import { Field as Field3, useField as useField2 } from "react-final-form";
import { borderColor as borderColor4, inputBorderRadius as inputBorderRadius2 } from "@sequencehq/core-theme";
import { dequal as dequal2 } from "dequal";
import { nth } from "@sequencehq/formatters";
import { jsx as jsx23, jsxs as jsxs13 } from "react/jsx-runtime";
var RecurrenceInput = ({ disabled }) => {
  const [isOpen, setIsOpen] = useState2(false);
  const groupRef = useRef4(null);
  const startDateInput = useField2("startDate", {
    subscription: { value: true }
  });
  const startDate = startDateInput.input.value;
  return /* @__PURE__ */ jsx23(
    Field3,
    {
      name: "recurrenceDayOfMonth",
      validate: required,
      isEqual: (a, b) => dequal2(a, b),
      children: ({ input, meta }) => {
        const { onChange, value } = input;
        const errorMessage = meta.error;
        const showInvalidState = meta.invalid && meta.touched;
        return /* @__PURE__ */ jsx23(
          Popover4,
          {
            variant: "dateInput",
            autoFocus: false,
            isOpen,
            placement: "bottom-start",
            returnFocusOnClose: false,
            isLazy: true,
            lazyBehavior: "unmount",
            children: /* @__PURE__ */ jsx23(PopoverAnchor3, { children: /* @__PURE__ */ jsxs13(FormControl3, { isInvalid: showInvalidState, zIndex: 1, children: [
              /* @__PURE__ */ jsxs13(Flex8, { children: [
                /* @__PURE__ */ jsx23(Label, { children: "Start billing period every" }),
                /* @__PURE__ */ jsx23(Flex8, { mt: "-6px", children: /* @__PURE__ */ jsx23(
                  InfoPopover,
                  {
                    title: "Proration",
                    body: "Sequence automatically calculates charges for partial billing periods. For example, if you set 14th Jan as your start date, but want new billing periods to start on the 1st of each month, the first billing period will be prorated (14th-31st Jan).",
                    placement: "right"
                  }
                ) })
              ] }),
              /* @__PURE__ */ jsxs13(
                InputGroup4,
                {
                  width: "250px",
                  ref: groupRef,
                  alignItems: "center",
                  position: "relative",
                  border: "1px solid",
                  outline: "2px solid",
                  borderRadius: inputBorderRadius2,
                  p: 0,
                  _focusWithin: {
                    outlineColor: IndigoIndigo509,
                    borderColor: "transparent"
                  },
                  ...{
                    borderColor: showInvalidState ? "transparent" : borderColor4,
                    outlineColor: showInvalidState ? RedRed605 : "transparent"
                  },
                  onFocus: () => {
                    return setIsOpen(true);
                  },
                  onBlur: (event) => {
                    if (!groupRef.current?.contains(event.relatedTarget)) {
                      setIsOpen(false);
                    }
                  },
                  tabIndex: disabled ? void 0 : 0,
                  children: [
                    /* @__PURE__ */ jsx23(
                      Input2,
                      {
                        readOnly: true,
                        variant: "plain",
                        disabled,
                        placeholder: "Select billing date",
                        fontSize: "14px",
                        lineHeight: "16px",
                        p: 3,
                        value: formatMonthly(value)
                      }
                    ),
                    /* @__PURE__ */ jsx23(InputRightElement3, { children: isOpen ? /* @__PURE__ */ jsx23(ChevronUpIcon3, {}) : /* @__PURE__ */ jsx23(ChevronDownIcon3, {}) }),
                    /* @__PURE__ */ jsx23(PopoverContent4, { children: /* @__PURE__ */ jsx23(PopoverBody4, { children: /* @__PURE__ */ jsx23(
                      MonthlyPopover,
                      {
                        onChange,
                        recurrenceDayOfMonth: value,
                        setIsOpen
                      }
                    ) }) })
                  ]
                }
              ),
              /* @__PURE__ */ jsx23(
                SubText,
                {
                  formHelperText: prorationHelper(startDate),
                  errorMessage,
                  value
                }
              )
            ] }) })
          }
        );
      }
    }
  );
};
var formatMonthly = (recurrenceDayOfMonth) => {
  return typeof recurrenceDayOfMonth === "number" ? `${nth(`${recurrenceDayOfMonth}`)} of the month` : "Select billing date";
};
var prorationHelper = (startDate) => (recurrenceDayOfMonth) => {
  if (!isValidDate(startDate) || !recurrenceDayOfMonth) {
    return;
  }
  const helperText = "First and last billing periods will be pro-rated";
  return startDate.getDate() !== recurrenceDayOfMonth ? helperText : void 0;
};

// src/components/Spotlight/Spotlight.tsx
import {
  Flex as Flex9,
  Button as Button5,
  InputLeftElement as InputLeftElement2,
  useMultiStyleConfig as useMultiStyleConfig5,
  Input as Input3,
  InputGroup as InputGroup5
} from "@chakra-ui/react";
import { internalBorder as internalBorder2 } from "@sequencehq/core-theme";
import { GreyGrey50, Lato16Regular } from "@sequencehq/design-tokens";

// src/components/Spotlight/util.ts
var getProductCountSubtitle = (priceCount) => {
  if (!priceCount) {
    return "No products";
  }
  return `${priceCount} product${priceCount > 1 ? "s" : ""}`;
};

// src/components/Spotlight/Spotlight.tsx
import { useCombobox as useCombobox2, useMultipleSelection } from "downshift";
import { useRef as useRef5 } from "react";
import { Plus as Plus3, Search } from "react-feather";
import { match as match9 } from "ts-pattern";
import { jsx as jsx24, jsxs as jsxs14 } from "react/jsx-runtime";
var toTokenList = (filteredItems, hasFilter, hasSelectedItems, addNewAction) => {
  const tokens = [];
  if (!hasFilter) {
    tokens.push({
      type: "title",
      location: "header",
      title: "Recent"
    });
  }
  tokens.push(
    ...filteredItems.map((item) => ({
      type: "model",
      location: "body",
      model: item
    }))
  );
  if (addNewAction) {
    if (filteredItems.length) {
      tokens.push({ type: "divider", location: "footer" });
    }
    if (!hasSelectedItems) {
      tokens.push({
        key: "add-new-button",
        type: "button",
        location: "footer",
        leftIcon: /* @__PURE__ */ jsx24(Plus3, {}),
        label: "Create new",
        onClick: addNewAction
      });
    }
  }
  return tokens;
};
var Spotlight = ({
  placeholder,
  items,
  itemToString,
  itemToContent,
  value,
  onChange,
  tokenIsDisabled,
  addNewAction,
  query,
  setQuery,
  onComplete
}) => {
  const parentRef = useRef5(null);
  const styles = useMultiStyleConfig5("CustomSelect");
  const supplementedItems = toTokenList(
    items,
    Boolean(query),
    Boolean(value.length),
    addNewAction
  );
  const {
    getDropdownProps
    /*getSelectedItemProps, removeSelectedItem*/
  } = useMultipleSelection({
    selectedItems: value,
    onStateChange({ selectedItems: newSelectedItems, type }) {
      switch (type) {
        case useMultipleSelection.stateChangeTypes.SelectedItemKeyDownBackspace:
        case useMultipleSelection.stateChangeTypes.SelectedItemKeyDownDelete:
        case useMultipleSelection.stateChangeTypes.DropdownKeyDownBackspace:
        case useMultipleSelection.stateChangeTypes.FunctionRemoveSelectedItem:
          onChange(newSelectedItems ?? []);
          break;
        default:
          break;
      }
    }
  });
  const {
    isOpen,
    getMenuProps,
    getInputProps,
    highlightedIndex,
    getItemProps
    // selectedItem
  } = useCombobox2({
    items: supplementedItems,
    itemToString: (token) => {
      return token?.type === "model" ? itemToString(token.model) : "";
    },
    defaultHighlightedIndex: -1,
    // after selection, highlight the first item.
    selectedItem: null,
    stateReducer(state, actionAndChanges) {
      const { changes, type } = actionAndChanges;
      switch (type) {
        case useCombobox2.stateChangeTypes.InputKeyDownEnter:
        case useCombobox2.stateChangeTypes.ItemClick:
          return {
            ...changes,
            highlightedIndex: state.highlightedIndex,
            isOpen: true
            // keep the menu open after selection.
            // highlightedIndex: 0 // with the first option highlighted.
          };
        default:
          return changes;
      }
    },
    onStateChange({
      inputValue: newInputValue,
      type,
      selectedItem: newSelectedItem
    }) {
      switch (type) {
        case useCombobox2.stateChangeTypes.InputKeyDownEnter:
        case useCombobox2.stateChangeTypes.ItemClick:
        case useCombobox2.stateChangeTypes.InputBlur:
          if (newSelectedItem?.type === "model") {
            if (value.some((item) => item.id === newSelectedItem.model.id)) {
              onChange(
                value.filter((item) => item.id !== newSelectedItem.model.id)
              );
            } else {
              onChange([...value, newSelectedItem.model]);
            }
          }
          break;
        case useCombobox2.stateChangeTypes.InputChange:
          {
            if (setQuery) {
              setQuery(newInputValue ?? "");
            }
          }
          break;
        default:
          break;
      }
    }
  });
  const dropDownProps = getDropdownProps({ preventKeyAction: isOpen });
  const { value: x, ...inputProps } = getInputProps(dropDownProps);
  return /* @__PURE__ */ jsxs14(Flex9, { flexDirection: "column", borderRadius: "8px", overflow: "hidden", pb: 2, children: [
    /* @__PURE__ */ jsx24(Flex9, { py: 5, px: 4, borderBottom: internalBorder2, children: /* @__PURE__ */ jsxs14(
      InputGroup5,
      {
        alignItems: "center",
        position: "relative",
        outline: "none",
        border: "none",
        m: 2,
        children: [
          /* @__PURE__ */ jsx24(InputLeftElement2, { pointerEvents: "none", width: "24px", height: "24px", children: /* @__PURE__ */ jsx24(Search, { color: GreyGrey50, width: "24px", height: "24px" }) }),
          /* @__PURE__ */ jsx24(
            Input3,
            {
              variant: "plain",
              placeholder,
              _placeholder: { color: GreyGrey50 },
              ...Lato16Regular,
              height: "autp",
              lineHeight: "24px",
              ...inputProps
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ jsx24(
      VirtualList,
      {
        parentRef,
        menuProps: { ...getMenuProps({}, { suppressRefError: true }) },
        tokens: supplementedItems,
        getItemProps,
        itemToContent,
        highlightedIndex,
        styles,
        tokenIsDisabled,
        px: 6,
        getSizeByType: getSizeByType3
      }
    ),
    value.length ? /* @__PURE__ */ jsx24(
      Flex9,
      {
        height: "48px",
        alignItems: "center",
        px: 6,
        justifyContent: "flex-end",
        children: /* @__PURE__ */ jsx24(
          Button5,
          {
            variant: "primary",
            onClick: () => onComplete(value),
            children: `Add ${getProductCountSubtitle(value.length)}`
          }
        )
      }
    ) : null
  ] });
};
var getSizeByType3 = (item) => {
  return match9(item.type).with("divider", () => 17).with("button", () => 48).otherwise(() => 40);
};

// src/components/TagInput/TagInput.tsx
import { useCombobox as useCombobox3 } from "downshift";
import {
  useMultiStyleConfig as useMultiStyleConfig6,
  Box as Box8,
  Popover as Popover5,
  PopoverAnchor as PopoverAnchor4,
  PopoverContent as PopoverContent5,
  PopoverBody as PopoverBody5,
  Input as ChakraInput4,
  InputGroup as InputGroup6,
  Portal as Portal4,
  InputRightElement as InputRightElement4,
  Flex as Flex10,
  Text as Text6,
  InputLeftElement as InputLeftElement3
} from "@chakra-ui/react";
import { useMemo, useRef as useRef6 } from "react";
import { ChevronDownIcon as ChevronDownIcon4, ChevronUpIcon as ChevronUpIcon4 } from "@chakra-ui/icons";
import { borderColor as borderColor5 } from "@sequencehq/core-theme";
import { Lato14Bold as Lato14Bold2, RedRed60 as RedRed606, IndigoIndigo50 as IndigoIndigo5010 } from "@sequencehq/design-tokens";
import { match as match10 } from "ts-pattern";
import { Badge as Badge2 } from "@sequencehq/core-components";
import { jsx as jsx25, jsxs as jsxs15 } from "react/jsx-runtime";
var getSupplementedItems2 = ({
  filteredItems,
  query,
  filterTags = []
}) => {
  const items = [];
  if (!query && filteredItems.length) {
    items.push({
      type: "title",
      location: "header",
      title: "Recent"
    });
  }
  items.push(
    ...filteredItems.map((item) => ({
      type: "model",
      location: "body",
      model: item
    }))
  );
  if (query && !filterTags.includes(query)) {
    if (filteredItems.length) {
      items.push({ type: "divider", location: "footer" });
    }
    items.push(createButton({ query }));
  }
  return items;
};
var TagInput2 = ({
  placeholder,
  items,
  itemToContent,
  disabled,
  value,
  onChange,
  width,
  isInvalid,
  setQuery,
  query,
  tokenIsDisabled,
  inputRef,
  handleBlur,
  filterTags
}) => {
  const groupRef = useRef6(null);
  const tokens = useMemo(() => {
    return getSupplementedItems2({
      filteredItems: items,
      query,
      filterTags
    });
  }, [items, query, filterTags]);
  const selectedItem = tokens.find((token) => token.type === "model" && token.model.id === value) ?? null;
  const {
    isOpen,
    getToggleButtonProps,
    getMenuProps,
    getItemProps,
    getInputProps,
    highlightedIndex
  } = useCombobox3({
    items: tokens,
    selectedItem,
    onSelectedItemChange: ({ selectedItem: selectedValue }) => {
      if (selectedValue?.type === "model") {
        onChange(selectedValue.model.id);
        setQuery("");
      } else {
        if (query && selectedValue?.type === "button") {
          onChange(query);
          setQuery("");
        }
      }
    },
    inputValue: query,
    itemToString: () => {
      return query ?? "";
    },
    onInputValueChange: ({ inputValue, ...rest }) => {
      if (setQuery && // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
      rest.type !== "__controlled_prop_updated_selected_item__") {
        setQuery(inputValue ?? "");
      }
    },
    stateReducer: (state, actionAndChanges) => {
      const { changes, type } = actionAndChanges;
      switch (type) {
        case useCombobox3.stateChangeTypes.InputKeyDownEnter:
        case useCombobox3.stateChangeTypes.ItemClick:
          if (!changes.selectedItem && !filterTags?.includes(query)) {
            return {
              ...changes,
              selectedItem: createButton({
                query
              })
            };
          }
          return changes;
        default:
          return changes;
      }
    }
  });
  const parentRef = useRef6(null);
  const controlRef = useRef6(null);
  const styles = useMultiStyleConfig6("CustomSelect");
  return /* @__PURE__ */ jsx25(
    Popover5,
    {
      isOpen: isOpen && Boolean(tokens.length),
      autoFocus: false,
      variant: "downshift",
      children: /* @__PURE__ */ jsxs15(Box8, { ref: controlRef, width, position: "relative", children: [
        /* @__PURE__ */ jsx25(PopoverAnchor4, { children: /* @__PURE__ */ jsxs15(
          InputGroup6,
          {
            ref: groupRef,
            display: "flex",
            width,
            alignItems: "center",
            position: "relative",
            outline: "2px solid",
            p: 0,
            pl: 2,
            onBlur: (event) => {
              if (!value) {
                setQuery("");
              }
              if (handleBlur && !groupRef.current?.contains(event.relatedTarget)) {
                handleBlur();
              }
            },
            _focusWithin: {
              outlineColor: IndigoIndigo5010,
              borderColor: "transparent"
            },
            __css: styles.toggleButton,
            ...{
              borderColor: isInvalid ? "transparent" : borderColor5,
              outlineColor: isInvalid ? RedRed606 : "transparent"
            },
            tabIndex: disabled ? void 0 : 0,
            children: [
              value ? /* @__PURE__ */ jsx25(InputLeftElement3, { width: "auto", position: "relative", flex: 0, children: /* @__PURE__ */ jsx25(
                Badge2,
                {
                  sentiment: "monospaced",
                  textTransform: "none",
                  size: "md",
                  onDelete: () => onChange(""),
                  children: value
                }
              ) }) : null,
              /* @__PURE__ */ jsx25(
                ChakraInput4,
                {
                  flex: 1,
                  variant: "plain",
                  disabled: disabled ?? Boolean(value),
                  placeholder: value ? "" : placeholder,
                  p: 3,
                  ...getInputProps({ ref: inputRef })
                }
              ),
              /* @__PURE__ */ jsx25(
                InputRightElement4,
                {
                  ...getToggleButtonProps({ disabled }),
                  height: "40px",
                  width: "24px",
                  right: "8px",
                  cursor: "pointer",
                  children: isOpen && tokens.length ? /* @__PURE__ */ jsx25(ChevronUpIcon4, { width: "20px", height: "20px" }) : /* @__PURE__ */ jsx25(ChevronDownIcon4, { width: "20px", height: "20px" })
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ jsx25(Portal4, { children: /* @__PURE__ */ jsx25(PopoverContent5, { width: controlRef.current?.offsetWidth, children: /* @__PURE__ */ jsx25(PopoverBody5, { children: /* @__PURE__ */ jsx25(
          VirtualList,
          {
            parentRef,
            menuProps: { ...getMenuProps({}, { suppressRefError: true }) },
            tokens,
            getItemProps,
            tokenIsDisabled,
            highlightedIndex,
            itemToContent,
            styles,
            getSizeByType: getSizeByType4
          }
        ) }) }) })
      ] })
    }
  );
};
var getSizeByType4 = (item) => {
  return match10(item.type).with("divider", () => 17).otherwise(() => 40);
};
var ButtonLabel = ({ query }) => /* @__PURE__ */ jsxs15(Flex10, { gap: "8px", alignItems: "center", children: [
  /* @__PURE__ */ jsx25(Text6, { ...Lato14Bold2, children: "Add" }),
  /* @__PURE__ */ jsx25(Badge2, { sentiment: "monospaced", size: "md", textTransform: "none", children: query })
] });
var createButton = ({
  query
}) => ({
  key: "add-new-button",
  type: "button",
  label: /* @__PURE__ */ jsx25(ButtonLabel, { query }),
  location: "footer",
  onClick: () => {
  }
});

// src/lib/noReturn/noReturn.ts
var noReturn = (fn) => (event) => void fn(event);
export {
  CalendarView,
  Checkbox,
  CheckboxField,
  ComboInputRemoteFilterNew,
  CompoundInputFieldNew,
  CustomSelectNew,
  FixedField,
  FormErrors,
  InfoPopover,
  Input,
  Label,
  ListButton,
  ListContent,
  ListDivider,
  ListTitle,
  MultiTagField,
  RecurrenceInput,
  Spotlight,
  SubText,
  TagInput2 as TagInput,
  TextInputField,
  VirtualList,
  createFormField,
  getSelectedItem,
  modelToToken,
  noReturn,
  validateEmailItem
};
/*! Bundled license information:

inflection/lib/inflection.js:
  (*!
   * inflection
   * Copyright(c) 2011 Ben Lin <ben@dreamerslab.com>
   * MIT Licensed
   *
   * @fileoverview
   * A port of inflection-js to node.js module.
   *)
*/
//# sourceMappingURL=index.js.map